import { initial_tooltip } from "./reducer"
import { TooltipState } from "./types"

export enum TooltipAction {
  UPDATE_TOOLTIP = 'UPDATE_TOOLTIP',
  HIDE_TOOLTIP = 'HIDE_TOOLTIP'
}

export const hideTooltip = () => ({
  type: TooltipAction.HIDE_TOOLTIP,
  data: initial_tooltip
})

export const showTooltip = (data: TooltipState) => ({
  type: TooltipAction.UPDATE_TOOLTIP,
  data
})
